var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current)?_c('app-md',{staticClass:"v-markdown--inline d-inline",attrs:{"tag":"span"}},[_vm._v(" "+_vm._s(_vm.current.metadata.description)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }